Ext.define('SA.view.color.ColorPalette', {
    alias: 'widget.color-palette',
    extend: 'Ext.view.View',

    itemSelector: '.sa-color-window-item',
    overItemCls: 'sa-color-window-item-over',

    tpl: [
        '<tpl for=".">',
            '<span class="sa-color-window-item">',
                '<span class="sa-color-window-item-inner" style="background: #{color};"></span>',
            '</span>',
        '</tpl>'
    ],

    store: {
        model: 'SA.model.color.Color',

        data: (() => {
            var baseColors = [],
                red = new SA.model.color.Color({color: 'FF0000'}),
                black = new SA.model.color.Color({color: '000000'}),
                colors = [];

            [0, 30, 45, 60, 90, 120, 160, 200, 240, 280, 320].forEach(hue => {
                baseColors.push(red.derive('h', hue));
            });

            baseColors.forEach(col => {
                colors.push(col.derive('l', 15 / 16));
            });

            baseColors.forEach(col => {
                colors.push(col.derive('l', 7 / 8));
            });

            baseColors.forEach(col => {
                colors.push(col.derive('l', 3 / 4));
            });

            baseColors.forEach(col => {
                colors.push(col.derive('l', 1 / 2));
            });

            baseColors.forEach(col => {
                colors.push(col.derive('l', 3 / 8));
            });

            baseColors.forEach(col => {
                colors.push(col.derive('l', 1 / 4));
            });

            var smallestJump = 1,
                largestJump = 3,
                averageJump = (smallestJump + largestJump) / 2,
                baseLength = baseColors.length,
                jumpCount = baseLength - 1,
                totalL = jumpCount * averageJump,
                cumulativeL = 0;

            baseColors.forEach((c, index) => {
                colors.push(black.derive('l', cumulativeL / totalL));

                cumulativeL += largestJump - (largestJump - smallestJump) * index / (jumpCount - 1);
            });

            return colors;
        })()
    },

    afterRender() {
        this.callParent();

        this.on('itemclick', (sm, record) => {
            this.fireEvent('select:color', this, record);
        });
    }
});